import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal } from '_zari/core'

import EgresoIngresoModoConstant from 'constants/egresoIngresoModo'

import { DownloadAxiosFile } from 'utils'

import * as CajaIngresoService from 'services/cajaEgresoIngreso.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const InsertarActualizarModal = ({ handleClose, show, reloadTable, editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      codigoGrupo: editarData.codigoGrupo ?? '',
      tipo: editarData.tipo ?? EgresoIngresoModoConstant.EGRESO,
      glosa: editarData.glosa ?? '',
      monto: editarData.monto ?? 0
    }),
    [editarData]
  )

  const submitHandler = React.useCallback(
    (data, { setSubmitting }) => {
      const funcSubmit = editarData._id
        ? () => CajaIngresoService.actualizarxId(editarData._id, data)
        : () => CajaIngresoService.insertarEstandar(data)

      funcSubmit()
        .then(({ data: data2 }) => {
          __zariContext.snack('success', 'El registro se ha agregado.')
          reloadTable()

          CajaIngresoService.generarReportexIdAsTicket(data2.hash)
            .then(({ data, headers }) => {
              DownloadAxiosFile.downloadAsBlob(data, headers)
              handleClose()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, editarData._id, reloadTable, handleClose]
  )

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{editarData._id ? 'INSERTAR' : 'ACTUALIZAR'} EGRESO-INGRESO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.TipoFormGroup fIsSubmitting={isSubmitting} values={values} />
              <FormGroups.CodigoGrupoFormGroup
                iError={errors.codigoGrupo}
                iTouched={touched.codigoGrupo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.MontoFormGroup iError={errors.monto} iTouched={touched.monto} fIsSubmitting={isSubmitting} />
              <FormGroups.GlosaFormGroup iError={errors.glosa} iTouched={touched.glosa} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Guardar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(InsertarActualizarModal)
